<template>
  <div class="send-mail-success">
    <el-dialog
        :visible.sync="sendMailSuccessVisible"
        :show-close="false"
        :before-close="destroyOnClose"
        :close-on-click-modal="false"
        width="30%">
      <el-form
        ref="sendMailSuccessForm"
        class="send-mail-success-form"
        :model="sendMailSuccessForm"
        label-width="120px"
      >
        <div class="messages">
            <span>{{ message || '送付先にメールまたはＳＭＳを送りました。' }}</span>
            <br><br>
            <span>※1時間たっても受信しない場合はメールアドレスか携帯電話番号、もしくは生年月日が間違っている可能性がありますので、お手数ですが、再度お手続きを行ってください</span>
            <br>
        </div>
        <el-form-item>
            <el-button type="danger" @click="destroyOnClose()">完了</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'send-mail-success',
  // message: optional override of the first line (used by ForgotLoginId.vue); defaults to the
  // password-reset wording.
  props: ['sendMailSuccessVisible', 'message'],
  data () {
    return {
      sendMailSuccessForm: {
      }
    }
  },
  methods: {
    destroyOnClose () {
      this.$emit('hideSendMailSuccessModal', false)
      this.sendMailSuccessForm = {}
      this.$refs['sendMailSuccessForm'].resetFields()
    }
  }
}
</script>

<style scoped>
  .messages {
    text-align: left;
  }
</style>
